/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Closedeal_Card_Button2Inputs */

const en_coinvestments_closedeal_card_button2 = /** @type {(inputs: Coinvestments_Closedeal_Card_Button2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close now`)
};

/**
* | output |
* | --- |
* | "Close now" |
*
* @param {Coinvestments_Closedeal_Card_Button2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_closedeal_card_button2 = /** @type {((inputs?: Coinvestments_Closedeal_Card_Button2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Closedeal_Card_Button2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_closedeal_card_button2(inputs)
});
export { coinvestments_closedeal_card_button2 as "coInvestments_closeDeal_card_button" }